/* global maplibregl */

Apt.fn.extend('maps', {}, {
	/**
	 * Initialize pitching
	 */
	initPitch() {
		const scope = this;

		scope.pitched = false;

		$.events.on('$mapTerrain', 'click', () => {
			scope.pitched = ! scope.pitched;

			if (scope.pitched) {
				scope.setState();

				LS.analytics.interact('map', 'terrain');
			}

			scope.setPitch(scope.pitched);
		}, {
			delegate: scope.$overlay,
			namespace: scope.uid
		});

		['pitchend', 'rotateend', 'zoomend'].forEach(event => {
			scope.$public.bind('map', event, () => {
				if (scope.pitchTimer) {
					clearTimeout(scope.pitchTimer);
				}

				scope.pitchTimer = setTimeout(() => {
					clearTimeout(scope.pitchTimer);

					scope.pitchTimer = null;

					scope.togglePitch();
				}, 100);
			});
		});

		scope.togglePitch();
	},

	/**
	 * Toggle pitch control
	 */
	togglePitch() {
		const scope = this;

		if (! scope.map) {
			return;
		}

		const deep = scope.map.getZoom() >= 14;
		const pitch = scope.map.getPitch();

		scope.$parent.toggleClass('-can-terrain', deep);

		if (pitch && ! deep) {
			scope.setPitch(false);

			return;
		}

		const bearing = scope.map.getBearing();

		if (bearing || pitch) {
			scope.addPitch();
		} else if (! bearing) {
			scope.removePitch();
		}
	},

	/**
	 * Reset pitch setting
	 *
	 * @param {Boolean} [bearing=false]
	 */
	resetPitch(bearing) {
		const scope = this;
		const options = {
			pitch: 0
		};

		if (bearing) {
			options.bearing = 0;
		}

		scope.map.setTerrain(null);

		scope.map.jumpTo(options);

		scope.model.$set('terrain', false);

		scope.removeSource('depth');
	},

	/**
	 * Add pitch control
	 */
	addPitch() {
		const scope = this;

		if (scope.pitchControl) {
			return;
		}

		scope.pitchControl = new maplibregl.NavigationControl({
			showZoom: false
		});

		scope.map.addControl(scope.pitchControl, 'bottom-right');
	},

	/**
	 * Set pitch state
	 *
	 * @param [state=false]
	 */
	setPitch(state) {
		const scope = this;

		scope.pitched = state;

		if (scope.model) {
			scope.model.$merge({
				show: false,
				terrain: state
			});
		}

		scope.removeOptions();

		if (! state) {
			scope.resetPitch();

			return;
		}

		const map = scope.map;
		const id = 'depth';

		scope.addSource(id, {
			type: 'raster-dem',
			encoding: 'terrarium',
			tiles: [
				'https://cdn.landsearch.com/terrarium/{z}/{x}/{y}.png'
			],
			tileSize: 256,
			maxzoom: 15
		});

		map.setTerrain({
			source: id
		});

		scope.$public.ready(() => {
			map.jumpTo({
				pitch: 65
			});

			scope.setState(true);
		});
	},

	/**
	 * Disable pitch control
	 */
	removePitch() {
		const scope = this;

		if (scope.pitchControl) {
			scope.map.removeControl(scope.pitchControl);

			scope.pitchControl = null;
		}
	}
});